module.exports = __webpack_public_path__ + "img/tip.4c660655.png";